import React, { useState } from "react";
import { auth } from "../config/firebase";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import BackgroundImage from "../Components/Background";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const location = useLocation();

  const onSubmit = async (data) => {
    const { Email, Password } = data;
    try {
      await signInWithEmailAndPassword(auth, Email, Password);
      toast.success("User logged in successfully!", { position: "top-center" });
      const from = location.state?.from || "/";
      navigate(from);
    } catch (error) {
      console.error("Login error:", error);
      let errorMessage = "Error logging in";
      if (error.code === "auth/wrong-password") {
        errorMessage = "Incorrect password";
      } else if (error.code === "auth/user-not-found") {
        errorMessage = "User not found";
      }
      toast.error(errorMessage, { position: "top-center" });
    }
  };

  const handleResetPassword = async (email) => {
    if (!email) {
      toast.error("Please enter an email first", { position: "top-center" });
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      toast.success("If this email is registered, a reset link has been sent!", {
        position: "top-center",
      });
    } catch (error) {
      console.error("Reset password error:", error);
      toast.success("If this email is registered, a reset link has been sent!", {
        position: "top-center",
      });
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-black bg-opacity-60">
      <BackgroundImage />

      <div className="absolute inset-0 bg-black opacity-60 z-10"></div>

      <div className="relative z-20 bg-slate-900/50 backdrop-blur-sm rounded-lg p-6 border border-gray-100/20 max-w-lg w-full p-8">
        <h2 className="text-2xl sm:text-xl font-semibold text-yellow-400 text-center mb-6 tracking-wider newfont">
          Welcome Back to MovieHinge
        </h2>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="space-y-6"
        >
          <div>
            <label className="text-sm font-medium text-yellow-400 tracking-wider newfont">Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              {...register("Email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i,
                  message: "Invalid email format",
                },
              })}
              className="w-full p-3 mt-2 text-white bg-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-300"
            />
            {errors.Email && (
              <p className="text-red-500 text-xs mt-1">{errors.Email.message}</p>
            )}
          </div>

          <div>
            <label className="text-sm font-medium text-yellow-400 tracking-wider newfont">Password</label>
            <div className="relative">
              <input
                type={passwordVisible ? "text" : "password"} 
                placeholder="Enter your password"
                {...register("Password", {
                  required: "Password is required",
                  minLength: { value: 6, message: "Minimum 6 characters" },
                })}
                className="w-full p-3 mt-2 text-white bg-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-300"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 transform -translate-y-1/2"
                onClick={() => setPasswordVisible(!passwordVisible)} 
              >
                {passwordVisible ? (
                  <FaEyeSlash className="text-yellow-400" />
                ) : (
                  <FaEye className="text-yellow-400" />
                )}
              </button>
            </div>
            {errors.Password && (
              <p className="text-red-500 text-xs mt-1">{errors.Password.message}</p>
            )}
          </div>

          <div className="flex justify-end">
            <button
              type="button"
              className="text-sm text-amber-300 hover:text-amber-400 transition-colors "
              onClick={() => {
                const email = document.querySelector('input[type="email"]').value;
                handleResetPassword(email);
              }}
            >
              Forgot Password?
            </button>
          </div>


          <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
            <button
              type="submit"
              className="w-full py-3 text-white bg-gradient-to-r from-amber-200/90 to-yellow-400/90 rounded-lg hover:scale-105 transform transition-all tracking-wider newfont"
            >
              Log In
            </button>

            <span className="text-sm text-white tracking-wider newfont">
              New to MovieHinge?{" "}
              <button
                type="button"
                onClick={() => navigate("/SignUp")}
                className="text-amber-300 hover:text-amber-400 transition-colors"
              >
                Sign Up
              </button>
            </span>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;
